let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("058PH")).then(() => parcelRequire('aoN9y'));